// extracted by mini-css-extract-plugin
module.exports = {"Tooltip":"costarica_Tooltip__1FVHU","Indicador":"costarica_Indicador__2N41M","FadeIn":"costarica_FadeIn__zISWh","fadeIn":"costarica_fadeIn__3isQq"};